module.exports = __webpack_public_path__ + "static/bulb-58068a89679606e6e5d7f4f8dac44d5c.png";